<template>
    <div class="header">
        <DxDataGrid ref="dataGridRef" :data-source="dsUtilizatori" key-expr="ID" :allow-column-reordering="true"
            :allow-column-resizing="true" :column-auto-width="false" :column-min-width="50"
            column-resizing-mode="nextColumn" :show-borders="true" :sync-lookup-filter-values="false"
            :filter-sync-enabled="true" :show-row-lines="true" :show-column-lines="false"
            :selection="{ mode: 'single' }" :hover-state-enabled="true" :focused-row-enabled="true"
            @selection-changed="onSelectionChanged" class="border">
            <DxFilterRow :visible="true" />
            <DxPaging :page-size="5" :page-index="1" />
            <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
            <DxSearchPanel :visible="true" placeholder="Caută" :element-attr="{ class: 'search' }" />
            <DxSorting mode="multiple" />
            <DxStateStoring :enabled="true" :filterValue="false" storage-key="Users" />
            <DxToolbar>
                <DxItem>
                    <template #default>
                        <DxButton icon="add" type="success" @click="onAddClick" />
                    </template>
                </DxItem>
                <DxItem>
                    <template #default>
                        <DxButton icon="refresh" @click="onRefreshClick" />
                    </template>
                </DxItem>
            </DxToolbar>
            <DxEditing :allowUpdating="true" :allowDeleting="true" mode="popup" @click="onRowRemoving">
                <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="450" :height="300">
                    <DxToolbarItem :template="customTitleTemplate" />
                    <DxToolbarItem toolbar="bottom" widget="dxButton" location="after"
                        :options="successButtonOptions" />
                    <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="dangerButtonOptions" />
                </DxPopup>
                <DxFormGrid>
                    <DxItem :col-span="1" :col-count="1" item-type="group">
                        <DxItem data-field="Username" :editor-options="{ width: 410, disabled: true }" />
                    </DxItem>
                </DxFormGrid>
            </DxEditing>
            <DxColumn data-field="UserCompanyID" :visible="false" />
            <DxColumn data-field="Username" />
        </DxDataGrid>
        <DxPopupAdd :visible.sync="isModalVisible" :closeOnOutsideClick="false" :showCloseButton="false"
            :showTitle="true" :width="450" :height="300">
            <template #title>
                <div
                    style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
                    Adăugare
                </div>
            </template>
            <div>
                <DxForm :formData="formData">
                    <DxItem :col-span="1" :col-count="1" item-type="group">
                        <DxItem data-field="Username" :editor-options="{ width: 410 }">
                            <DxValidationRule>
                                <DxRequiredRule />
                            </DxValidationRule>
                        </DxItem>
                    </DxItem>
                </DxForm>
                <div style="display: flex; justify-content: flex-end; gap: 8px;">
                    <DxButton text="Salvează" type="success" width="100" @click="onSaveAdd" />
                    <DxButton text="Închide" type="danger" width="100" @click="onCancel" />
                </div>
            </div>
        </DxPopupAdd>
    </div>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue';
import { DxButton } from 'devextreme-vue/button';
import DxPopupAdd, { DxToolbarItem } from 'devextreme-vue/popup';
import { DxItem, DxForm, DxLabel } from 'devextreme-vue/form';
import { locale, loadMessages } from 'devextreme/localization';
import 'devextreme/dist/css/dx.light.css';
import 'devextreme/dist/css/dx.common.css';
import notify from 'devextreme/ui/notify';
import AUTH_Users from '@/services/AUTH/AUTH_Users';
import {
    DxColumn,
    DxDataGrid,
    DxFilterRow,
    DxLoadPanel,
    DxPaging,
    DxSelection,
    DxSorting,
    DxStateStoring,
    DxToolbar,
    DxEditing,
    DxPopup,
    DxItem as DxItemForm,
    DxForm as DxFormGrid,
    DxValidationRule,
    DxRequiredRule,
} from 'devextreme-vue/data-grid';


export default defineComponent({

    components: {
        DxToolbar,
        DxDataGrid,
        DxColumn,
        DxSorting,
        DxSelection,
        DxFilterRow,
        DxStateStoring,
        DxLoadPanel,
        DxPaging,
        DxButton,
        DxItem,
        DxPopup,
        DxForm,
        DxLabel,
        DxEditing,
        DxPopupAdd,
        DxToolbarItem,
        DxItemForm,
        DxFormGrid,
        DxValidationRule,
        DxRequiredRule,
    },
    data() {
        return {
            dsUtilizatori: [] as any[],
            isModalVisible: false,
            formData: {
                UserCompanyID: ''
            },
            dataGridRef: ref<DxDataGrid | null>(null),
            deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
            successButtonOptions: {
                type: 'success',
                stylingMode: 'contained',
                text: 'Salvează',
                onClick: () => {
                    this.onSaveEdit();
                },
            },
            dangerButtonOptions: {
                type: 'danger',
                stylingMode: 'contained',
                text: 'Închide',
                onClick: () => {
                    this.onCancelEdit();
                },
            },
            customTitleTemplate() {

                return `<div style="background-color: #ff2c21; font-size: 16px; float: right; height:47px; width:460px; color: white;
                        font-weight: bold;  padding: 12px; padding-right: 453px;  position: relative;  left: 30px;">
                          Editare
                        </div>`;
            },
        };
    },
    methods: {
        getUtilizatori() {
            AUTH_Users.get()
                .then((response: any) => {
                    this.dsUtilizatori = response.data ?? [];
                })
                .catch((e: Error) => console.error(e));
        },
        onSelectionChanged(e: any) {
            const row = e?.selectedRowsData?.[0] ?? null;
            this.$emit('selection-changed', row);
        },

        onClick() {
            this.isModalVisible = true;
        },
        onRefreshClick() {
            this.getUtilizatori();
            notify('Datele au fost actualizate cu succes!', 'success', 1000)
        },
        onAddClick() {
            this.isModalVisible = true;
        },
        onRowRemoving(e: any) {
            // const id = e.key ?? e.data?.id;
            // e.cancel = new Promise((resolve) => {
            //     AUTH_Users.delete(id)
            //         .then(() => { notify('Datele au fost șterse cu succes!', 'success', 2000); resolve(false); })
            //         .catch(() => { notify('A apărut o eroare la ștergere!', 'error', 2000); resolve(true); });
            // });
        },
        onSaveAdd() {
            if (!this.formData.Nume || this.formData.Nume.trim() === '') {
                notify('Completați câmpul obligatoriu "Nume"!', 'error', 1000);
                return;
            }
            if (!this.formData.Cod || this.formData.Cod.trim() === '') {
                notify('Completați câmpul obligatoriu "Cod"!', 'error', 1000);
                return;
            }
            if (!this.formData.MeniuConfig || this.formData.MeniuConfig.trim() === '') {
                notify('Completați câmpul obligatoriu "Meniu Configurat"!', 'error', 1000);
                return;
            }
            const savePromise = this.$refs.dataGridRef?.instance?.saveEditData();
            console.log(this.formData);

            const body = {
                ...this.formData,
                Meniu: this.formData.Meniu ?? true
            };

            // AUTH_Users.save(body)
            //     .then((response) => {
            //         this.isModalVisible = false;
            //         notify('Datele au fost salvate cu succes!', 'success', 1000);
            //         this.formData = { Nume: '', Cod: '', Explicatie: '', Tip: '', Meniu: true };
            //         this.getDrepturiCustom();
            //     })
            //     .catch((error) => {
            //         console.error(error);
            //         notify('Datele există deja!', 'error', 1000);
            //     });
        },
        onCancel() {
            this.isModalVisible = false;
        },
        setDeleteConfirmationMessage() {
            const dataGrid = this.$refs.dataGridRef?.instance;
            dataGrid.option('editing', {
                allowUpdating: true,
                allowDeleting: true,
                mode: 'popup',
                texts: {
                    confirmDeleteMessage: this.deleteConfirmationMessage,
                    confirmDeleteTitle: "Confirmare Ștergere",
                }
            });
        },
        onCancelEdit() {
            this.dataGridRef?.instance?.cancelEditData();
        },
    },
    mounted() {
        this.getUtilizatori();
        this.dataGridRef = this.$refs.dataGridRef as DxDataGrid;
        this.setDeleteConfirmationMessage();
        loadMessages({
            "ro": {
                "Yes": "Da",
                "No": "Nu",
            }
        });
        locale('ro');
    },
});
</script>
<style scoped>
.border {
    border-radius: 8px;
}
</style>
